import { Auth0Provider, Auth0ProviderOptions } from "@auth0/auth0-react";
import { FC, PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";

// [AI_START::module id="auth0-provider-with-navigate" purpose="Auth0 SPA provider with react-router redirect; persist tokens so localhost consent is not re-prompted on every reload" links=["useAccessToken", "withApolloClient"]]

const Auth0ProviderWithNavigate: FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const navigate = useNavigate();

  const onRedirectCallback: Auth0ProviderOptions["onRedirectCallback"] = (
    appState
  ) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN as string}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID as string}
      onRedirectCallback={onRedirectCallback}
      // localstorage: survive reloads. Auth0 always shows consent on localhost;
      // memory cache forced a consent + silent-auth loop after every refresh.
      cacheLocation="localstorage"
      authorizationParams={{
        audience: process.env.REACT_APP_AUTH0_AUDIENCE as string,
        redirect_uri: window.location.origin,
      }}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithNavigate;

// [AI_END::auth0-provider-with-navigate]
